import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, URL_API } from "../../variable";
import { css } from "@emotion/react";
import { Modal } from "react-bootstrap";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { toast } from "react-toastify";
import { Link, useHistory } from "react-router-dom";
import CopyToClipboard from 'react-copy-to-clipboard'
import { FaRegClone } from 'react-icons/fa'

import styles from "../referrelProgram/styles.css";

function DealerList() {
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();
  const [sliders, setSliders] = useState([]);
  const [promoUsers, setPromoUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const [showModal2, setShowModal2] = useState(false);
  const handleCloseModal2 = () => setShowModal2(false);
  const [filteredUser, setFilteredUser] = useState();
  const [loading, setloading] = useState([]);

  useEffect(() => {
    getSliders();
    const interval = setInterval(() => {
      getSliders();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const getSliders = () => {
    setloading(true)
    axios.get(URL_API + "dealers").then((response) => {
      if (response?.data?.status === 200) {
        setloading(false)
        setSliders(response?.data?.dealers);
      }
    });
  };

  const showPromoCodeUsedUsers = (promoCode, urlCode) => {

    try {
      setShowModal(true)
      axios
        .get(URL_API + `getReferrelLinkDetailAdmin/${promoCode}/${urlCode}`)
        .then((response) => {
          if (response?.data?.status == 200) {
            setPromoUsers(response?.data?.data)
          }
        })
    } catch (e) {
    }
  }
  const [copied, setCopied] = useState(false);

  function setCopiedFunction() {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }

  const changeEnquiryStatus = (name, email, phone, promoCode, urlCode, oldStatus, newStatus) => {
    let formData = new FormData()
    formData.append('name', name)
    formData.append('email', email)
    formData.append('phone', phone)
    formData.append('promo_code', promoCode)
    formData.append('url_code', urlCode)
    formData.append('old_status', oldStatus)
    formData.append('new_status', newStatus)
    try {
      // setShowModal(true)
      axios
        .post(URL_API + `changeEnquiryStatus/${promoCode}/${urlCode}`, formData)
        .then((response) => {
          if (response?.data?.status == 200) {
            showPromoCodeUsedUsers(promoCode, urlCode)
            toast.success("Status Updated Successfully", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 3000,
            });
            // setPromoUsers(response?.data?.data)
          }
        })
    } catch (e) {
    }
  }

  const destroySlider = (id) => {
    axios.post(URL_API + `auth/admin/slider-destroy/${id}`).then((response) => {
      if (response.data.status === 200) {
        history.push("/admin/sliders");
        toast.success("Slider Deleted Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        getSliders();
      }
    });
  };

  const handleFilter = (email) => {
    setShowModal2(true)
    const value = email;
    const filtered = sliders.filter(user => user?.email.includes(value));
    setFilteredUser(filtered);
  };


  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4" style={{ fontWeight: "100" }}>
                  Barakah Hijama | <i class="fa fa-home" aria-hidden="true"></i> |
                  Dealers
                </CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                {/* <Link to={`/admin/slider/create`}>
                  <strong>Add Slider + </strong>
                </Link> */}
              </div>

              
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>

                      <th>Date</th>
                      <th>Updated At</th>
                      {/* <th className="text-right">Salary</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      loading === true ?
                        <>
                          <tr style={{ alignContent: 'center', textAlign: 'center' }}>
                            <td colSpan={13}>
                              <img src="/loading.gif" height={60} width={60} />
                            </td>
                          </tr>
                        </>
                        :
                        <>

                          {sliders?.map(
                            (slider, index) => {
                              return (
                                <tr>
                                  <td>{index + 1}</td>
                                  <td>{slider?.name}</td>
                                  <td>{slider?.email}</td>

                                  <td>  {slider?.phone}
                                    <CopyToClipboard
                                      text={slider?.phone}
                                      onCopy={() => setCopiedFunction()}
                                    >
                                      <div className={`${styles?.copy_text} ${copied ? 'active' : ""}`}>
                                        <button className="btn btn-primary"><i><FaRegClone /></i></button>
                                      </div>
                                    </CopyToClipboard>
                                  </td>
                                  <td>
                                    {moment(slider?.created_at).format(
                                      " DD MMMM,YYYY"
                                    )}
                                  </td>
                                  <td>
                                    {moment(slider?.updated_at).format(
                                      " DD MMMM,YYYY"
                                    )}
                                  </td>
                                </tr>
                              );
                            }
                          )}</>
                    }
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          show={showModal}
          onHide={handleCloseModal}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: "100%",

          }}
        >
          <Modal.Header >
            <b></b>
            <div style={{ backgroundColor: '#45656', borderRadius: '50%' }} onClick={handleCloseModal} >
              <b style={{ cursor: 'pointer' }}>
                <i class="fa fa-times" aria-hidden="true"></i>
              </b>
            </div>
          </Modal.Header>
          <Table responsive>
            <thead className="text-primary">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Full Name</th>
                <th scope="col">Email Address</th>
                <th scope="col">Phone Number</th>
                <th scope="col">URL Code</th>
                <th scope="col">Promo Code</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {
                promoUsers?.map(
                  (user, index) => {
                    return (
                      <tr>
                        <td>  {index + 1}</td>
                        <td>{user?.name}</td>
                        <td>{user?.email}</td>
                        <td>{user?.phone}</td>
                        <td>{user?.url_code}
                          <CopyToClipboard
                            text={user?.url_code}
                            onCopy={() => setCopiedFunction()}
                          >
                            <div className={`${styles.copy_text} ${copied ? 'active' : ""}`}>
                              <button className="btn btn-primary"><i><FaRegClone /></i></button>
                            </div>
                          </CopyToClipboard>
                        </td>
                        <td>{user?.promo_code}</td>
                        <td>{user?.status}</td>
                        <td>{user?.status}</td>
                        <td>{user?.status}</td>
                        <td>{user?.status}</td>
                        <td>
                          <select
                            onChange={(e) => changeEnquiryStatus(
                              user?.name,
                              user?.email,
                              user?.phone,
                              user?.promo_code,
                              user?.url_code,
                              user?.status,
                              e?.target?.value)}>
                            <option value={""}>--Change Status--</option>
                            {user?.status == 'Lead Submitted' ?
                              <>
                                <option value={"Deal Confirmed"}  >Deal Confirmed</option>
                              </>
                              : ''}



                            {user?.status == 'Deal Confirmed' ?
                              <>
                                <option value={"Processed"}>Processed</option>
                              </>
                              : ''}
                          </select>
                        </td>
                      </tr>
                    );
                  }
                  // )
                )
              }
            </tbody>
          </Table>
        </Modal>



        <Modal
          show={showModal2}
          onHide={handleCloseModal2}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: "100%",

          }}
        >
          <Modal.Header >
            <b></b>
            <div style={{ backgroundColor: '#45656', borderRadius: '50%' }} onClick={handleCloseModal2} >
              <b style={{ cursor: 'pointer' }}>
                <i class="fa fa-times" aria-hidden="true"></i>
              </b>
            </div>
          </Modal.Header>
          <Table responsive>
            <thead className="text-primary">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Account Name</th>
                <th scope="col">Account Number</th>
                <th scope="col">IBAN</th>
                <th scope="col">Bank Name</th>
                <th scope="col">Feed Back</th>
                {/* <th scope="col">Action</th> */}
              </tr>
            </thead>
            <tbody>
              {
                filteredUser?.slice(0, 1).map(
                  (user, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{user?.account_holder_name}</td>
                        <td>{user?.account_number}</td>
                        <td>{user?.iban}</td>
                        <td>{user?.bank_name}</td>
                        <td>{user?.feed_back}</td>
                      </tr>
                    );
                  }
                  // )
                )
              }
            </tbody>
          </Table>
        </Modal>
      </div >
    </>
  );
}

export default DealerList;
